/**
 * Area specialized in displaying Calendar pages
 */
fx.ns("shared.stage", class CalendarArea extends shared.stage.Area {
    constructor(month, page, model, parentContainer, side, preview, options) {
        super(page, model, parentContainer, side, preview);

        this.LOSTBORDER = 5;

        this._activeSide = "";
        this._activePart = "";

        this.listenUpdates(page.components, true);
        this.listenUpdates(this.calendar, true);
        this._month = month;
    }

    /***************** Getters / Setters *****************/

    get month() {
        return this._month;
    }

    get date() {
        let year = new Date().getFullYear();
        return new Date(year, this._month);
    }

    get page() {
        return this.element;
    }

    set page(val) {
        super.element = val;
    }

    get pageWidth() {
        return this.realWidth;
    }

    get pageHeight() {
        return this.realHeight / 2;
    }

    get dragActive() {
        return this._dragActive;
    }

    set dragActive(val) {
        this._dragActive = val;
    }

    get active() {
        return this._active;
    }

    set active(val) {
        this._active = val;

        if (val)
            this.addClass("active");
        else
            this.removeClass("active");
    }

    // return active part of pages : top / bottom / center (for slice)
    get activePart() {
        return this._activePart;
    }

    set activePart(val) {
        if (!this.initialized)
            return;

        this._activePart = val;

        this.activeSide = val;

        if (!this.loaded) return;

        if (this.backgroundTop)
            this.backgroundTop.toggleClass("active", val == "top");

        if (this.backgroundBottom)
            this.backgroundBottom.toggleClass("active", val == "bottom");

        this.trigger("active-part-changed");
    }

    // return active part of pages : top / bottom 
    get activeSide() {
        return this._activeSide;
    }

    set activeSide(val) {
        this._activeSide = val;
    }

    /**
     * - backgroundColors : show background colors buttons
     * - addText : show addText buttons
     */
    get options() {
        if (!this._options)
            this._options = {};

        return this._options;
    }

    set options(val) {
        this._options = val;
    }

    get calendar() {
        return this.creation;
    }

    set calendar(val) {
        this._creationcalendar = val;

        if (this.initialized && this.loaded)
            this._positionBackgrounds();
    }

    get lostBorder() {
        return 0;
    }

    get extraWidth() {
        return 0;
    }

    get areaHeight() {
        return this.calendar.pageHeight * 2;
    }

    get areaWidth() {
        return this.calendar.pageWidth;
    }

    get stageContainerWidth() {
        return this.areaWidth;
    }

    get stageContainerHeight() {
        return this.areaHeight;
    }

    get stageHeight() {
        return this.areaHeight;
    }

    get stageWidth() {
        return this.areaWidth;
    }

    /***************** Overrides *****************/

    applyLayout(layout, side) {

        if (this.data.isCover && !this.creation.isSinglePage)
            side = "bottom";

        if (!this.data.isCover && !this.creation.isSinglePage)
            side = "top";

        this._applyLayout(layout, false, side);
    }

    create(already) {
        super.create();

        if (!this.rawDisplay && !already) {
            this.container = new fx.components.Box("Container");
            this.addChild(this.container, { width: "100%", height: "100%" });

            // backgrounds
            this.backgroundTop = new fx.components.Box("background-left");
            this.backgroundTop.pointerEvents = false;
            this.container.addChild(this.backgroundTop);

            this.backgroundBottom = new fx.components.Box("background-right");
            this.backgroundBottom.pointerEvents = false;
            this.container.addChild(this.backgroundBottom);

            this.binding = new shared.stage.CoverBinding(this.calendar, this.data);
            this.binding.pointerEvents = false;
            this.container.addChild(this.binding, { left: 0, top: this.data.isCover ? 0 : "center", width: "100%", height: 10 });

            if (this.calendar.hasWhole) {
                this.wholeBottom = new fx.components.Box("whole");

                this.wholeBottom.toolTip = "coucou"
                this.container.addChild(this.wholeBottom, { left: "center", bottom: 6 * this.data.creation.extraScale, width: 6 * this.data.creation.extraScale, height: 6 * this.data.creation.extraScale });
                this.wholeBottom.css("box-shadow", "inset 0px 0px " + 2 * this.data.creation.extraScale + "px " + 1 * this.data.creation.extraScale + "px rgba(0, 0, 0, 0.16)");

                if (!this.data.isCover) {
                    this.wholeTop = new fx.components.Box("whole");
                    this.wholeTop.pointerEvents = false;
                    this.container.addChild(this.wholeTop, { left: "center", top: 6 * this.data.creation.extraScale, width: 6 * this.data.creation.extraScale, height: 6 * this.data.creation.extraScale });
                    this.wholeTop.css("box-shadow", "inset 0px 0px " + 2 * this.data.creation.extraScale + "px " + 1 * this.data.creation.extraScale + "px rgba(0, 0, 0, 0.16)");
                }

            }
        }
    }


    load() {
        if (this.stage && this.stage.loaded && this.page == this.stage.data)
            return;

        if (!this.page)
            return;

        this.updateSidePositions();

        super.load();

        this.updateChildPositions();
        this.updateCoverBindingPosition();

    }

    updateCoverBindingPosition() {
        let elements = fx.dom.find(".CoverBinding .content .element .asset");
        if (elements) {
            if (elements.length > 0) {
                const top = -3 * this.calendar.extraScale;
                elements.forEach(el => {
                    el.style.top = top + "px";
                });
            }
        }
        elements = fx.dom.find(".CoverBinding .content .wall-single .asset");
        if (elements) {
            if (elements.length > 0) {
                const top = -10 * this.calendar.extraScale;
                elements.forEach(el => {
                    el.style.top = top + "px";
                });
            }
        }
    }

    unload() {
        if (!this.loaded)
            return;

        super.unload();

        this.activePart = "";
    }


    enableActions(val) {
        this._actionsEnabled = val;
    }

    // scale changed
    refresh() {
        super.refresh();

        this.activePart = "";
    }

    /***************** Actions *****************/

    setBackground(color, side) {
        if (!side && !this.activePart)
            this.activePart = this.data.isCover ? "bottom" : "top";

        this.page.updateBackgroundColor(color, side || this.activePart, true);
    }

    activeOver(direction) {

    }

    addComponent(data) {

        if (this.data.isCover)
            data.side = "bottom";

        if (!data.side && !this.activePart)
            this.activePart = this.data.isCover ? "bottom" : "top";

        if (!data.side)
            data.side = this.activePart;

        this.activePart = data.side;

        this.page.addComponent(data, "", this.creation.pageWidth, this.creation.pageHeight);
    }

    updatePhoto(data) {
        if (!this.data) return;

        let components = this.data.photosComponents;

        if (this.activeSide)
            components = this.data.photosComponents.filter(a => (this.activeSide == "top") ?
                (fx.graphics.getBoundingRect(a, a.rotation).x < this.calendar.pageWidth) :
                (fx.graphics.getBoundingRect(a, a.rotation).x >= this.calendar.pageWidth + this.extraWidth));

        components = components.sort((a, b) => (b.width * b.height) - (a.width * a.height));

        let emptyPhotos = components.filter(a => a.content == "");

        if (emptyPhotos.length > 0) {
            emptyPhotos.sort((a, b) => a.x - b.x);
            emptyPhotos.getItemAt(0).content = data.content;
        }
        else
            if (components.length > 0)
                components.getItemAt(0).content = data.content;
            else
                this.addPhoto(data);
    }

    addPhoto(data) {
        if (data.side)
            this.activeSide = data.side;

        // if activeSide is empty
        if (this.activeSide == "") {
            // check if empty photos on double page from the left to the right
            let components = this.data.photosComponents.sort((a, b) => a.x - b.x);
            for (let i = 0; i < components.length; i++) {
                let component = components.getItemAt(i);
                if (component.content == "") {
                    component.content = data.content;
                    return;
                }
            }
            // otherwise, set activeSide to empty : which mean it will fill first page and then second one
            this.activeSide = "";
        }

        let activeSide = (this.activeSide == "") ? "top" : this.activeSide;

        let components = this.data.photosComponents.filter(a => (activeSide == "top") ?
            (fx.graphics.getBoundingRect(a, a.rotation).x < this.calendar.pageWidth) :
            (fx.graphics.getBoundingRect(a, a.rotation).x >= this.calendar.pageWidth + this.extraWidth));

        if (components.length >= fx.get("settings").numMaxPhoto && this.activeSide == "") {
            activeSide = "bottom";

            components = this.data.photosComponents.filter(a => (activeSide == "top") ?
                (fx.graphics.getBoundingRect(a, a.rotation).x < this.calendar.pageWidth) :
                (fx.graphics.getBoundingRect(a, a.rotation).x >= this.calendar.pageWidth + this.extraWidth));
        }

        components.sort((a, b) => a.x - b.x);

        // first find if a photo component is empty, and use it
        // otherwise find layout with enougth pics
        for (let i = 0; i < components.length; i++) {
            let component = components.getItemAt(i);
            if (component.content == "") {
                component.content = data.content;
                return;
            }
        }

        // if already max pics
        if (components.length >= fx.get("settings").numMaxPhoto) {
            // so we update biggest picture
            components.sort((a, b) => (b.width * b.height) - (a.width * a.height));
            components.getItemAt(0).content = data.content;
            return;
        }

        let photos = [];
        for (let i = 0; i < components.length; i++) {
            let component = components.getItemAt(i);
            let photo = this.model.photos.find({ id: component.content })
            if (photo)
                photos.push(photo)
        }

        let photo = this.model.photos.find({ id: data.content });
        if (photo)
            photos.push(photo)

        let layouts = fx.service("LayoutsGenerator").getLayouts(photos);

        if (layouts.length == 0) return;

        let pageWidth = this.calendar.pageWidth;
        this.data.addPhoto(photos, activeSide, pageWidth, this.pageHeight, this.extraWidth, layouts[0]);
    }

    /// --------------------- //

    updateSidePositions() {
        if (!this.initialized || !this.page) return;

        this.height(this.areaHeight);
        this.stageContainer.height(this.areaHeight);
        this.stage.height(this.areaHeight);
        this.stage.left(0);

        if (this.container) {
            this.container.left(0);
            this.container.height(this.areaHeight);
        }

        if (this.backgroundTop) {
            this.backgroundTop.show();
            this.backgroundTop.left(0);
            this.backgroundTop.top(this.data.isCover ? -this.calendar.pageHeight : 0);
        }

        if (this.backgroundBottom) {
            this.backgroundBottom.show();
            this.backgroundBottom.left(0);
            this.backgroundBottom.top(this.data.isCover ? 0 : this.calendar.pageHeight);
        }
    }

    _positionBackgrounds() {
        if (!this.calendar)
            return;

        if (this.backgroundTop)
            this.backgroundTop.viewport({ left: 0, top: this.data.isCover ? -this.calendar.pageHeight : 0, width: "100%", height: this.calendar.pageHeight });

        if (this.backgroundBottom)
            this.backgroundBottom.viewport({ left: 0, top: this.data.isCover ? 0 : this.calendar.pageHeight, width: "100%", height: this.calendar.pageHeight });
    }

    onReady() {
        super.onReady();

        this._positionBackgrounds();
    }

    updateDisplay() {
        this.resize();
        this.position();

        this.updateSidePositions();

        this.updateChildPositions();

        this.onDisplayUpdated();
    }

    updateChildPositions() {
        if (!this.loaded) return;
    }



    /***************** Events *****************/

    onDataEvent(event) {
        super.onDataEvent(event);

        switch (event.type) {
            case "cover-updated":

                if (!this.initialized) return;

                this._positionBackgrounds();

                /*if (this.binding) {
                    this.binding.width(this.calendar.sliceHeight);
                    this.binding.toggle(this.calendar.isSpiral || (this.calendar.isBind && this.data.isCover))
                }*/

                this.width(this.areaWidth);
                this.stageContainer.width(this.stageContainerWidth);
                this.stage.width(this.stageWidth);

                if (this.container)
                    this.container.updateDisplay();

                this.updateDisplay();

                if (this.stage.loaded)
                    for (let i = 0; i < this._childs.length; i++)
                        if (this.stage._childs[i])
                            this.stage._childs[i].onDisplayUpdated();
                break;
        }
    }


    onDataUpdated(action) {
        super.onDataUpdated(action);
    }


    onChildUpdated(action) {
        super.onChildUpdated(action);
    }

    onDeletePage() {
        this.data.event("remove-page", this.page);
    }

    selectActivePart(e) {
        if (!this.stage || !this.stage.node) return;

        // if on mobile event contains "center" parameter for position
        // otherwise on desktop, it contains pageX, pageY
        let position = e.center || { x: e.pageX, y: e.pageY };

        let offset = fx.graphics.globalToLocal(this.stage.node, position.x, position.y)

        offset.y = offset.y / this.scale;

        let pageHeight = this.calendar.pageHeight;

        if (fx.dom.parent(e.target, ".Area")) {
            if (!fx.dom.parent(e.target, this.node))
                this.activePart = "";
            else
                if (offset.y < pageHeight)
                    this.activePart = "top";
                else
                    this.activePart = "bottom";
        }
        else
            if (fx.dom.parent(e.target, ".Board"))
                this.activePart = "";
    }

});